<template>
      <div class="container-archive" v-if="!loading">
        <div class="container bg-dark p-5">
          <div class="row">
            <div class="col-md-12">
              <div class="text-white border-bottom border-dark" >
                <b>{{ item.org.TYPE_OBJECT }}
                  <template v-if="item.org.CODE_PPE_EGE">{{ item.org.CODE_PPE_EGE }} <small class="badge badge-pill badge-primary">ЕГЭ</small></template>
                  <template v-if="item.org.CODE_PPE_OGE"> {{ item.org.CODE_PPE_OGE }} <small class="badge badge-pill badge-info">ОГЭ</small></template>
                </b>
                <br>
                {{ item.org.ADDRESS }}
                <br>
                <span>{{ item.org.NAME_OO }}</span>
                <br>
                <span>ауд. {{ item.room.CLASSROOM }}</span>
              </div>
            </div>
            <div class="col-md-12 pt-5" v-if="from && to">
              <stream :htmlId="'archive' + item.SYS_GUID" :from="from" :to="to" :id="item.SYS_GUID"></stream>
            </div>
            <div v-else class="video-placeholder col-md-12 mt-3 d-flex align-items-center justify-content-around">
              <div class="text-light text-center">
                <b>Задайте параметры и нажмите "Показать"</b>
              </div>
            </div>
            <div class="col-md-12">
              <br>
              <div class="row">
                <div class="col-md-6">
                  <div class="text-white">C</div>
                  <b-form-datepicker dark class="bg-dark text-light border-1 border-white" id="date1" v-bind="locale" v-model="date_start" width="100%"
                                     :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :max="max"></b-form-datepicker>
                  <b-input-group class="mt-4 time-input">
                    <b-input-group-prepend>
                      <b-form-timepicker  class="bg-dark text-light" id="time1" v-bind="locale" v-model="time_start" width="100%"
                                          no-close-button button-only></b-form-timepicker>
                    </b-input-group-prepend>
                    <masked-input  class="form-control bg-dark text-light" v-model="time_start" type="text" placeholder="чч:мм" mask="11:11"></masked-input>
                  </b-input-group>
                </div>
                <div class="col-md-6">
                  <div class="text-white">ПО</div>
                  <b-form-datepicker dark :class="{ 'bg-dark text-light' : true, 'is-invalid' : error.length > 0 }" id="date2" v-bind="locale" v-model="date_end" width="100%"
                                     :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :max="max"></b-form-datepicker><br>

                  <b-input-group :class="{ 'time-input' : true, 'is-invalid' : error.length > 0 }">
                    <b-input-group-prepend>
                      <b-form-timepicker  :class="{ 'bg-dark text-light' : true, 'is-invalid' : error.length > 0 }" id="time2" v-bind="locale" v-model="time_end"
                                          no-close-button button-only></b-form-timepicker>
                    </b-input-group-prepend>
                    <masked-input :class="{ 'form-control bg-dark text-light' : true, 'is-invalid' : error.length > 0 }" v-model="time_end" type="text" placeholder="чч:мм" mask="11:11"></masked-input>
                  </b-input-group>


                  <div class="invalid-tooltip ml-3">
                    {{ error }}
                  </div>
                </div>
                <div class="col-md-12 mt-4 text-right">
                  <button class="btn btn-primary" @click.prevent="apply()">Показать</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import Stream from '@/components/Archive'
  import moment from 'moment'
  import { apiQuery } from "../api";
  import MaskedInput from 'vue-masked-input'

  export default {
    name: "Archive",
    components: { Stream, MaskedInput },
    data() {
      return {
        item: {},
        from: '',
        to: '',
        date_start: '',
        time_start: '',
        date_end: '',
        time_end: '',
        max: new Date(),
        error: '',
        loading: true,
        locale: {
          labelHours: 'Часов',
          labelMinutes: 'Минут',
          labelSeconds: 'Секунд',
          labelIncrement: 'Больше',
          labelDecrement: 'Меньше',
          labelSelected: 'Выбрано',
          labelNoTimeSelected: 'Время не выбрано',
          labelCloseButton: 'Закрыть',
          labelPrevDecade: 'Предыдущее десятилетие',
          labelPrevYear: 'Предыдущий год',
          labelPrevMonth: 'Предыдущий месяц',
          labelCurrentMonth: 'Текущий месяц',
          labelNextMonth: 'Следующий месяц',
          labelNextYear: 'Следующий год',
          labelNextDecade: 'Следующее десятилетие',
          labelToday: 'Сегодня',
          labelNoDateSelected: 'Дата не выбрана',
          labelCalendar: 'Календарь',
          labelNav: 'Навигация',
          labelHelp: ''
        },
      }
    },
    mounted() {
        apiQuery('private', 'data-get-record', {
          table: window.x2.tables.pakview,
          recordId: this.$route.params.id
        }, false).then(async response => {
          this.item = response
          await Promise.all([
            apiQuery('private', 'data-get-record', {
              table: window.x2.tables.rooms,
              recordId: response.CLS_FK.value
            }, false).then(room => { this.item['room'] = room }),
            apiQuery('private', 'data-get-record', {
              table: window.x2.tables.schools,
              recordId: response.ORG_FK.value
            }, false).then(org => { this.item['org'] = org })
          ]).then(() => { this.loading = false })
        })
    },
    watch: {
      date_start() {
        this.error = ''
      },
      date_end() {
        this.error = ''
      },
      time_start() {
        this.error = ''
      },
      time_end() {
        this.error = ''
      }
    },
    methods: {
      apply() {
        let start = '';
        let end = '';
        if (this.date_start) {
          start = moment(this.date_start + ' ' + this.time_start)
        }
        if (this.date_end !== '') {
          end = moment(this.date_end + ' ' + this.time_end)
        }
        else {
          end = start.add(1, 'day')
        }
        if (!end.isSameOrAfter(start)) {
          this.error = 'Дата "ПО" не может быть меньше даты "С"'
        }
        else {
          this.from = start.format('DD.MM.YYYY HH:mm:ss')
          this.to = end.format('DD.MM.YYYY HH:mm:ss')
        }

      }
    },
  }
</script>
